var l="@hpstellar/core/color-selection",o={getAdditionalColorsLabel:function(l){return"".concat(l," additional colors available")},label:"Available colors"};export{l as colorSelectionTestId,o as colorSelectionTranslations};
